var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "text-login" }, [
            _vm._v(_vm._s(_vm.$t("general.system_name")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "fs-18 mb-2 text-black text-center m-20" },
                [_vm._v(_vm._s(_vm.$t("change_pass.title")))]
              ),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("div", { staticClass: "error-message" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("i", { staticClass: "icon-warning mr-2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "errror-txt" }, [
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.$t("error.title")))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.errorMessage))
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tooltip
                ? _c("div", { staticClass: "tooltip-changepass-inner" }, [
                    _vm._v("\n                        - 8文字以上 "),
                    _c("br"),
                    _vm._v(
                      "\n                        - 半角英字(大文字、小文字)、半角数字、記号(下記) "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - 記号 <>{}()-+*/_!$%&#?@;:,. "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - 大文字を1文字以上含める "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - 数字を1文字以上含める "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - 記号を1文字以上含める "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - ユーザーIDは使用できません"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        - 前回と同じパスワードは使用できません\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-box mt-50" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-input" }, [
                    _c("i", { staticClass: "icon-left icon-lock-red" }),
                    _vm._v(" "),
                    _vm.typeInputPass === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                regex: /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\-+*/_!$%&#?@;:,.]{8,}$/
                              },
                              expression:
                                "{required: true,regex:/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\\-+*/_!$%&#?@;:,.]{8,}$/}"
                            }
                          ],
                          ref: "password",
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.password"),
                            name: "password",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.password)
                              ? _vm._i(_vm.password, null) > -1
                              : _vm.password
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.password,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.password = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.password = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.password = $$c
                              }
                            }
                          }
                        })
                      : _vm.typeInputPass === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                regex: /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\-+*/_!$%&#?@;:,.]{8,}$/
                              },
                              expression:
                                "{required: true,regex:/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\\-+*/_!$%&#?@;:,.]{8,}$/}"
                            }
                          ],
                          ref: "password",
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.password"),
                            name: "password",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.password, null) },
                          on: {
                            change: function($event) {
                              _vm.password = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                regex: /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\-+*/_!$%&#?@;:,.]{8,}$/
                              },
                              expression:
                                "{required: true,regex:/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\\-+*/_!$%&#?@;:,.]{8,}$/}"
                            }
                          ],
                          ref: "password",
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.password"),
                            name: "password",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: _vm.typeInputPass
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: _vm.showHidePass,
                        on: { click: _vm.showPassword }
                      },
                      [_c("i", { staticClass: "icon-eye" })]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "help_change_pass fa fa-question-circle",
                      attrs: { "aria-hidden": "true" },
                      on: { click: _vm.showTooltip }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("password")
                    ? _c("span", { staticClass: "error-text" }, [
                        _vm._v(_vm._s(_vm.errors.first("password")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-input" }, [
                    _c("i", { staticClass: "icon-left icon-lock-red" }),
                    _vm._v(" "),
                    _vm.typeInputConfirm === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm,
                              expression: "confirm"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|confirmed:password",
                              expression: "'required|confirmed:password'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.confirm"),
                            name: "confirm",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.confirm)
                              ? _vm._i(_vm.confirm, null) > -1
                              : _vm.confirm
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.confirm,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.confirm = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.confirm = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.confirm = $$c
                              }
                            }
                          }
                        })
                      : _vm.typeInputConfirm === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm,
                              expression: "confirm"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|confirmed:password",
                              expression: "'required|confirmed:password'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.confirm"),
                            name: "confirm",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.confirm, null) },
                          on: {
                            change: function($event) {
                              _vm.confirm = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm,
                              expression: "confirm"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|confirmed:password",
                              expression: "'required|confirmed:password'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t("change_pass.confirm"),
                            name: "confirm",
                            "data-vv-as": _vm.$t("change_pass.password"),
                            type: _vm.typeInputConfirm
                          },
                          domProps: { value: _vm.confirm },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirm = $event.target.value
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: _vm.showHideConfirm,
                        on: { click: _vm.showConfirm }
                      },
                      [_c("i", { staticClass: "icon-eye" })]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("confirm")
                    ? _c("span", { staticClass: "error-text" }, [
                        _vm._v(_vm._s(_vm.errors.first("confirm")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.clickChangePass,
                        expression: "!clickChangePass"
                      }
                    ],
                    staticClass: "mt-50"
                  },
                  [
                    _c("button", { staticClass: "btn btn-login" }, [
                      _vm._v(_vm._s(_vm.$t("button.ok")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.clickChangePass,
                        expression: "clickChangePass"
                      }
                    ],
                    staticClass: "row no-gutters w-100 mt-50"
                  },
                  [
                    _c("div", { staticClass: "col-6" }, [
                      _c("button", { staticClass: "btn btn-login" }, [
                        _vm._v(_vm._s(_vm.$t("button.ok")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 pl-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-gray-53 btn-back",
                          attrs: { type: "button" },
                          on: { click: _vm.back }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.back")))]
                      )
                    ])
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo-link", attrs: { href: "#" } }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_jtb.png"), alt: "Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f28f42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f28f42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/ResetPassword/ResetPassword.vue
// module id = null
// module chunks = 